
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-us",
      function () {
        return require("private-next-pages/email-us/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-us"])
      });
    }
  